import { useSettings } from 'components/SettingsProvider';

import { MEDIA_ROOT } from './environment';

export function pluralize(
  num: number,
  singular: string,
  plural: string,
): string {
  return num === 1 ? singular : plural;
}

export function formatBytes(bytes: number) {
  if (!+bytes) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
}

export function toFixed(value: number) {
  const stringified = String(value);

  if (stringified.length === 1) {
    return `${stringified}.0`;
  }

  return stringified.slice(0, 3);
}

export function formatDate(
  date: string,
  locale: string,
  customFormatJson?: string,
) {
  const dateFormat = new Date(date);

  if (customFormatJson) {
    const jsObject = JSON.parse(customFormatJson);

    return new Intl.DateTimeFormat(locale, jsObject).format(dateFormat);
  }

  return new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  }).format(dateFormat);
}

type Size = '120' | '400' | '800';

export function useImage() {
  const {
    utils: { shopDomain },
  } = useSettings();

  /**
   *
   * @param key Image key
   *
   * @param size Image size Size = '120' | '400' | '800'
   * @default '800'
   *
   * @returns string
   */

  const getImageUrl = (key: string, size: Size = '800') => {
    if (import.meta.env.MODE === 'storybook' || Shopify.designMode) {
      return key;
    }

    const sizesMap: Record<Size, string> = {
      120: '120x120',
      400: '400x400',
      800: '800x800',
    };

    return `${MEDIA_ROOT}${shopDomain}/review/${key}/${sizesMap[size]}`;
  };

  return {
    getImageUrl,
  };
}
